const getDefaultState = (() => ({
    shareBuybackData : {},
    shareholderShareBuybackData: [],
    newBeneficialOwners : [],
    existingBeneficialOwners : [],
    newRegistrableControllers: [],
    existingRegistrableControllers: [],
    completeShareBuyback: {},
    sharesBuybackId: undefined,
    companyProcessId: undefined,
}));

export default {
    namespaced: true,

    state: getDefaultState(),

    getters: {
        getAll(state)
        {
            return state;
        },

        getShareBuybackData(state) {
            return state.shareBuybackData;
        },

        getShareholderShareBuybackData(state) {
            return state.shareholderShareBuybackData;
        },

        getNewBeneficialOwners(state) {
            return state.newBeneficialOwners;
        },

        getOldBeneficialOwners(state) { 
            return state.existingBeneficialOwners;
        },

        getNewRegistrableControllers(state) {
            return state.newRegistrableControllers;
        },

        getOldRegistrableControllers(state) {
            return state.existingRegistrableControllers;
        },

        getCompleteShareBuyback(state) {
            return state.completeShareBuyback;
        },
    },

    mutations: {
        CLEAR(state)
        {
            Object.assign(state, getDefaultState());
        },

        SET_SHARE_BUYBACK(state, shareBuybackData) {
            state.shareBuybackData = shareBuybackData;
        },

        SET_SHAREHOLDER_SHARE_BUYBACK_DATA(state, shareholderShareBuybackData) {
            state.shareholderShareBuybackData = shareholderShareBuybackData;
        },

        SET_NEW_BENEFICIAL_OWNERS(state, newBeneficialOwners) {
            state.newBeneficialOwners = newBeneficialOwners;
        },

        SET_EXISTING_BENEFICIAL_OWNERS(state, existingBeneficialOwners) {
            state.existingBeneficialOwners = existingBeneficialOwners;
        },

        SET_NEW_REGISTRABLE_CONTROLLERS(state, newRegistrableControllers) {
            state.newRegistrableControllers = newRegistrableControllers;
        },

        SET_EXISTING_REGISTRABLE_CONTROLLERS(state, existingRegistrableControllers) {
            state.existingRegistrableControllers = existingRegistrableControllers;
        },

        SET_COMPLETE_SHARE_BUYBACK(state, completeShareBuybackData) {
            state.completeShareBuyback = completeShareBuybackData;
        },

        SET_SHARE_BUYBACK_ID(state, id) {
            state.sharesBuybackId = id;
        },

        SET_COMPANY_PROCESS_ID(state, id) {
            state.companyProcessId = id;
        }
    },

    actions: {
        SET_SHARE_BUYBACK_DATA({ commit }, data) {
            // first clear all data
            commit('CLEAR');
           
            commit('SET_SHARE_BUYBACK', data.share_details);
            commit('SET_SHAREHOLDER_SHARE_BUYBACK_DATA', data.shareholder_data);

            commit('SET_NEW_BENEFICIAL_OWNERS', data.beneficial_owners_data.newBeneficialOwners);
            commit('SET_EXISTING_BENEFICIAL_OWNERS', data.beneficial_owners_data.existingBeneficialOwners);

            commit('SET_NEW_REGISTRABLE_CONTROLLERS', data.registrable_controllers_data.newRegistrableControllers);
            commit('SET_EXISTING_REGISTRABLE_CONTROLLERS', data.registrable_controllers_data.existingRegistrableControllers);
           
            commit('SET_COMPLETE_SHARE_BUYBACK', data.completion_data);
        },
    },
};
